import { setIn, type FormikErrors } from 'formik'
import type { PluginEmbedSettings } from '@sportninja/common/features/account/apiAccess'

/**
 * Folds flat `'branding.fontSize'`-style error keys into the nested shape
 * Formik reads with `getIn`, so each field finds its own message.
 */
export const toFormikErrors = (
  flat: Record<string, string>
): FormikErrors<PluginEmbedSettings> =>
  Object.entries(flat).reduce<FormikErrors<PluginEmbedSettings>>(
    (errors, [path, message]) => setIn(errors, path, message),
    {}
  )
